import React, { useEffect, useRef } from 'react';
import ClipboardJS from 'clipboard';
import { Tooltip } from 'react-tooltip';
import { useTSState } from '../TSContext';
const TextSelectionListener = () => {
    const tooltipRef = useRef(null);
    const { state, setStateLocal } = useTSState();
    const isActive = state.currentScreen === 'player';
    useEffect(() => {
        const handleMouseUp = (event) => {
            var _a;
            const selectedText = (_a = window.getSelection()) === null || _a === void 0 ? void 0 : _a.toString();
            if (selectedText && selectedText.length > 3) {
                const clipboard = new ClipboardJS(document.body, {
                    text: () => selectedText
                });
                clipboard.on('success', () => {
                    var _a;
                    (_a = tooltipRef.current) === null || _a === void 0 ? void 0 : _a.open({
                        position: { x: event.pageX, y: event.pageY },
                        content: 'Text copied!',
                        place: 'top'
                    });
                    setStateLocal({ selectedText });
                    setTimeout(() => {
                        var _a;
                        (_a = tooltipRef.current) === null || _a === void 0 ? void 0 : _a.close();
                    }, 1500);
                    clipboard.destroy();
                });
                clipboard.on('error', () => {
                    clipboard.destroy();
                });
            }
        };
        if (isActive) {
            document.addEventListener('mouseup', handleMouseUp);
        }
        return () => {
            document.removeEventListener('mouseup', handleMouseUp);
        };
    }, [isActive, setStateLocal]);
    return React.createElement(Tooltip, { ref: tooltipRef, style: { zIndex: 10000 } });
};
export default TextSelectionListener;
